import { render, staticRenderFns } from "./BoxSelectPartial.vue?vue&type=template&id=20e8df09&scoped=true&"
import script from "./BoxSelectPartial.vue?vue&type=script&lang=js&"
export * from "./BoxSelectPartial.vue?vue&type=script&lang=js&"
import style0 from "./BoxSelectPartial.vue?vue&type=style&index=0&id=20e8df09&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e8df09",
  null
  
)

export default component.exports